var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pctop)?_c('Header'):_vm._e(),_c('div',{staticClass:"shop-container"},[(_vm.pctop)?_c('swiper-small',{attrs:{"list":_vm.bannerArr}}):_vm._e(),_c('jshop',{attrs:{"pageData":_vm.pageData}})],1),(_vm.pcbottom)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }